!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("prop-types"), require("classnames"), require("date-fns/isDate"), require("date-fns/isValid"), require("date-fns/format"), require("date-fns/addMinutes"), require("date-fns/addHours"), require("date-fns/addDays"), require("date-fns/addWeeks"), require("date-fns/addMonths"), require("date-fns/addYears"), require("date-fns/subMinutes"), require("date-fns/subHours"), require("date-fns/subDays"), require("date-fns/subWeeks"), require("date-fns/subMonths"), require("date-fns/subYears"), require("date-fns/getSeconds"), require("date-fns/getMinutes"), require("date-fns/getHours"), require("date-fns/getDay"), require("date-fns/getDate"), require("date-fns/getWeek"), require("date-fns/getMonth"), require("date-fns/getQuarter"), require("date-fns/getYear"), require("date-fns/getTime"), require("date-fns/setSeconds"), require("date-fns/setMinutes"), require("date-fns/setHours"), require("date-fns/setMonth"), require("date-fns/setQuarter"), require("date-fns/setYear"), require("date-fns/min"), require("date-fns/max"), require("date-fns/differenceInCalendarDays"), require("date-fns/differenceInCalendarMonths"), require("date-fns/differenceInCalendarWeeks"), require("date-fns/differenceInCalendarYears"), require("date-fns/startOfDay"), require("date-fns/startOfWeek"), require("date-fns/startOfMonth"), require("date-fns/startOfQuarter"), require("date-fns/startOfYear"), require("date-fns/endOfDay"), require("date-fns/endOfWeek"), require("date-fns/endOfMonth"), require("date-fns/isEqual"), require("date-fns/isSameDay"), require("date-fns/isSameMonth"), require("date-fns/isSameYear"), require("date-fns/isSameQuarter"), require("date-fns/isAfter"), require("date-fns/isBefore"), require("date-fns/isWithinInterval"), require("date-fns/toDate"), require("date-fns/parse"), require("date-fns/parseISO"), require("react-onclickoutside"), require("react-popper")) : "function" == typeof define && define.amd ? define(["exports", "react", "prop-types", "classnames", "date-fns/isDate", "date-fns/isValid", "date-fns/format", "date-fns/addMinutes", "date-fns/addHours", "date-fns/addDays", "date-fns/addWeeks", "date-fns/addMonths", "date-fns/addYears", "date-fns/subMinutes", "date-fns/subHours", "date-fns/subDays", "date-fns/subWeeks", "date-fns/subMonths", "date-fns/subYears", "date-fns/getSeconds", "date-fns/getMinutes", "date-fns/getHours", "date-fns/getDay", "date-fns/getDate", "date-fns/getWeek", "date-fns/getMonth", "date-fns/getQuarter", "date-fns/getYear", "date-fns/getTime", "date-fns/setSeconds", "date-fns/setMinutes", "date-fns/setHours", "date-fns/setMonth", "date-fns/setQuarter", "date-fns/setYear", "date-fns/min", "date-fns/max", "date-fns/differenceInCalendarDays", "date-fns/differenceInCalendarMonths", "date-fns/differenceInCalendarWeeks", "date-fns/differenceInCalendarYears", "date-fns/startOfDay", "date-fns/startOfWeek", "date-fns/startOfMonth", "date-fns/startOfQuarter", "date-fns/startOfYear", "date-fns/endOfDay", "date-fns/endOfWeek", "date-fns/endOfMonth", "date-fns/isEqual", "date-fns/isSameDay", "date-fns/isSameMonth", "date-fns/isSameYear", "date-fns/isSameQuarter", "date-fns/isAfter", "date-fns/isBefore", "date-fns/isWithinInterval", "date-fns/toDate", "date-fns/parse", "date-fns/parseISO", "react-onclickoutside", "react-popper"], t) : t((e = e || self).DatePicker = {}, e.React, e.PropTypes, e.classNames, e.isDate, e.isValidDate, e.format, e.addMinutes, e.addHours, e.utils, e.utils$1, e.addMonths, e.addYears, e.subMinutes, e.subHours, e.subDays, e.subWeeks, e.subMonths, e.subYears, e.getSeconds, e.getMinutes, e.getHours, e.getDay, e.getDate, e.dfgetWeek, e.getMonth, e.getQuarter, e.getYear, e.getTime, e.setSeconds, e.setMinutes, e.setHours, e.utils$2, e.utils$3, e.setYear, e.min, e.max, e.differenceInCalendarDays, e.differenceInCalendarMonths, e.differenceInCalendarWeeks, e.differenceInCalendarYears, e.startOfDay, e.startOfWeek, e.startOfMonth, e.startOfQuarter, e.startOfYear, e.endOfDay, e.endOfWeek, e.endOfMonth, e.dfIsEqual, e.dfIsSameDay, e.dfIsSameMonth, e.dfIsSameYear, e.dfIsSameQuarter, e.isAfter, e.isBefore, e.isWithinInterval, e.toDate, e.parse, e.parseISO, e.onClickOutside, e.ReactPopper);
}(this, function (e, t, r, n, a, o, s, p, i, c, l, d, u, h, f, m, y, v, w, D, k, g, b, C, _, O, S, P, M, E, N, Y, x, T, I, L, j, F, q, W, R, A, B, H, K, Q, V, U, $, z, G, J, X, Z, ee, te, re, ne, ae, oe, se, pe) {
  "use strict";

  function ie(e) {
    return (ie = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function ce(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }

  function le(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function de(e, t, r) {
    return t && le(e.prototype, t), r && le(e, r), e;
  }

  function ue(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = r, e;
  }

  function he() {
    return (he = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function fe(e, t) {
    var r = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), r.push.apply(r, n);
    }

    return r;
  }

  function me(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = null != arguments[t] ? arguments[t] : {};
      t % 2 ? fe(Object(r), !0).forEach(function (t) {
        ue(e, t, r[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : fe(Object(r)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
      });
    }

    return e;
  }

  function ye(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && we(e, t);
  }

  function ve(e) {
    return (ve = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function we(e, t) {
    return (we = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function De(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function ke(e, t) {
    return !t || "object" != typeof t && "function" != typeof t ? De(e) : t;
  }

  function ge(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var r,
          n = ve(e);

      if (t) {
        var a = ve(this).constructor;
        r = Reflect.construct(n, arguments, a);
      } else r = n.apply(this, arguments);

      return ke(this, r);
    };
  }

  function be(e, t) {
    switch (e) {
      case "P":
        return t.date({
          width: "short"
        });

      case "PP":
        return t.date({
          width: "medium"
        });

      case "PPP":
        return t.date({
          width: "long"
        });

      case "PPPP":
      default:
        return t.date({
          width: "full"
        });
    }
  }

  function Ce(e, t) {
    switch (e) {
      case "p":
        return t.time({
          width: "short"
        });

      case "pp":
        return t.time({
          width: "medium"
        });

      case "ppp":
        return t.time({
          width: "long"
        });

      case "pppp":
      default:
        return t.time({
          width: "full"
        });
    }
  }

  t = t && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t, r = r && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r, n = n && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n, a = a && Object.prototype.hasOwnProperty.call(a, "default") ? a.default : a, o = o && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o, s = s && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s, p = p && Object.prototype.hasOwnProperty.call(p, "default") ? p.default : p, i = i && Object.prototype.hasOwnProperty.call(i, "default") ? i.default : i, c = c && Object.prototype.hasOwnProperty.call(c, "default") ? c.default : c, l = l && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l, d = d && Object.prototype.hasOwnProperty.call(d, "default") ? d.default : d, u = u && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u, h = h && Object.prototype.hasOwnProperty.call(h, "default") ? h.default : h, f = f && Object.prototype.hasOwnProperty.call(f, "default") ? f.default : f, m = m && Object.prototype.hasOwnProperty.call(m, "default") ? m.default : m, y = y && Object.prototype.hasOwnProperty.call(y, "default") ? y.default : y, v = v && Object.prototype.hasOwnProperty.call(v, "default") ? v.default : v, w = w && Object.prototype.hasOwnProperty.call(w, "default") ? w.default : w, D = D && Object.prototype.hasOwnProperty.call(D, "default") ? D.default : D, k = k && Object.prototype.hasOwnProperty.call(k, "default") ? k.default : k, g = g && Object.prototype.hasOwnProperty.call(g, "default") ? g.default : g, b = b && Object.prototype.hasOwnProperty.call(b, "default") ? b.default : b, C = C && Object.prototype.hasOwnProperty.call(C, "default") ? C.default : C, _ = _ && Object.prototype.hasOwnProperty.call(_, "default") ? _.default : _, O = O && Object.prototype.hasOwnProperty.call(O, "default") ? O.default : O, S = S && Object.prototype.hasOwnProperty.call(S, "default") ? S.default : S, P = P && Object.prototype.hasOwnProperty.call(P, "default") ? P.default : P, M = M && Object.prototype.hasOwnProperty.call(M, "default") ? M.default : M, E = E && Object.prototype.hasOwnProperty.call(E, "default") ? E.default : E, N = N && Object.prototype.hasOwnProperty.call(N, "default") ? N.default : N, Y = Y && Object.prototype.hasOwnProperty.call(Y, "default") ? Y.default : Y, x = x && Object.prototype.hasOwnProperty.call(x, "default") ? x.default : x, T = T && Object.prototype.hasOwnProperty.call(T, "default") ? T.default : T, I = I && Object.prototype.hasOwnProperty.call(I, "default") ? I.default : I, L = L && Object.prototype.hasOwnProperty.call(L, "default") ? L.default : L, j = j && Object.prototype.hasOwnProperty.call(j, "default") ? j.default : j, F = F && Object.prototype.hasOwnProperty.call(F, "default") ? F.default : F, q = q && Object.prototype.hasOwnProperty.call(q, "default") ? q.default : q, W = W && Object.prototype.hasOwnProperty.call(W, "default") ? W.default : W, R = R && Object.prototype.hasOwnProperty.call(R, "default") ? R.default : R, A = A && Object.prototype.hasOwnProperty.call(A, "default") ? A.default : A, B = B && Object.prototype.hasOwnProperty.call(B, "default") ? B.default : B, H = H && Object.prototype.hasOwnProperty.call(H, "default") ? H.default : H, K = K && Object.prototype.hasOwnProperty.call(K, "default") ? K.default : K, Q = Q && Object.prototype.hasOwnProperty.call(Q, "default") ? Q.default : Q, V = V && Object.prototype.hasOwnProperty.call(V, "default") ? V.default : V, U = U && Object.prototype.hasOwnProperty.call(U, "default") ? U.default : U, $ = $ && Object.prototype.hasOwnProperty.call($, "default") ? $.default : $, z = z && Object.prototype.hasOwnProperty.call(z, "default") ? z.default : z, G = G && Object.prototype.hasOwnProperty.call(G, "default") ? G.default : G, J = J && Object.prototype.hasOwnProperty.call(J, "default") ? J.default : J, X = X && Object.prototype.hasOwnProperty.call(X, "default") ? X.default : X, Z = Z && Object.prototype.hasOwnProperty.call(Z, "default") ? Z.default : Z, ee = ee && Object.prototype.hasOwnProperty.call(ee, "default") ? ee.default : ee, te = te && Object.prototype.hasOwnProperty.call(te, "default") ? te.default : te, re = re && Object.prototype.hasOwnProperty.call(re, "default") ? re.default : re, ne = ne && Object.prototype.hasOwnProperty.call(ne, "default") ? ne.default : ne, ae = ae && Object.prototype.hasOwnProperty.call(ae, "default") ? ae.default : ae, oe = oe && Object.prototype.hasOwnProperty.call(oe, "default") ? oe.default : oe, se = se && Object.prototype.hasOwnProperty.call(se, "default") ? se.default : se;
  var _e = {
    p: Ce,
    P: function P(e, t) {
      var r,
          n = e.match(/(P+)(p+)?/),
          a = n[1],
          o = n[2];
      if (!o) return be(e, t);

      switch (a) {
        case "P":
          r = t.dateTime({
            width: "short"
          });
          break;

        case "PP":
          r = t.dateTime({
            width: "medium"
          });
          break;

        case "PPP":
          r = t.dateTime({
            width: "long"
          });
          break;

        case "PPPP":
        default:
          r = t.dateTime({
            width: "full"
          });
      }

      return r.replace("{{date}}", be(a, t)).replace("{{time}}", Ce(o, t));
    }
  },
      Oe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;

  function Se(e) {
    var t = e ? "string" == typeof e || e instanceof String ? oe(e) : ne(e) : new Date();
    return Me(t) ? t : null;
  }

  function Pe(e, t, r, n) {
    var a = null,
        o = Ke(r) || He(),
        p = !0;
    return Array.isArray(t) ? (t.forEach(function (t) {
      var r = ae(e, t, new Date(), {
        locale: o
      });
      n && (p = Me(r) && e === s(r, t, {
        awareOfUnicodeTokens: !0
      })), Me(r) && p && (a = r);
    }), a) : (a = ae(e, t, new Date(), {
      locale: o
    }), n ? p = Me(a) && e === s(a, t, {
      awareOfUnicodeTokens: !0
    }) : Me(a) || (t = t.match(Oe).map(function (e) {
      var t = e[0];
      return "p" === t || "P" === t ? o ? (0, _e[t])(e, o.formatLong) : t : e;
    }).join(""), e.length > 0 && (a = ae(e, t.slice(0, e.length), new Date())), Me(a) || (a = new Date(e))), Me(a) && p ? a : null);
  }

  function Me(e) {
    return o(e) && ee(e, new Date("1/1/1000"));
  }

  function Ee(e, t, r) {
    if ("en" === r) return s(e, t, {
      awareOfUnicodeTokens: !0
    });
    var n = Ke(r);
    return r && !n && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !n && He() && Ke(He()) && (n = Ke(He())), s(e, t, {
      locale: n || null,
      awareOfUnicodeTokens: !0
    });
  }

  function Ne(e, t) {
    var r = t.hour,
        n = void 0 === r ? 0 : r,
        a = t.minute,
        o = void 0 === a ? 0 : a,
        s = t.second;
    return Y(N(E(e, void 0 === s ? 0 : s), o), n);
  }

  function Ye(e, t) {
    var r = t && Ke(t) || He() && Ke(He());
    return _(e, r ? {
      locale: r
    } : null);
  }

  function xe(e, t) {
    return Ee(e, "ddd", t);
  }

  function Te(e) {
    return A(e);
  }

  function Ie(e, t) {
    var r = Ke(t || He());
    return B(e, {
      locale: r
    });
  }

  function Le(e) {
    return H(e);
  }

  function je(e) {
    return K(e);
  }

  function Fe(e, t) {
    return e && t ? X(e, t) : !e && !t;
  }

  function qe(e, t) {
    return e && t ? J(e, t) : !e && !t;
  }

  function We(e, t) {
    return e && t ? Z(e, t) : !e && !t;
  }

  function Re(e, t) {
    return e && t ? G(e, t) : !e && !t;
  }

  function Ae(e, t) {
    return e && t ? z(e, t) : !e && !t;
  }

  function Be(e, t, r) {
    var n,
        a = A(t),
        o = V(r);

    try {
      n = re(e, {
        start: a,
        end: o
      });
    } catch (e) {
      n = !1;
    }

    return n;
  }

  function He() {
    return ("undefined" != typeof window ? window : global).__localeId__;
  }

  function Ke(e) {
    if ("string" == typeof e) {
      var t = "undefined" != typeof window ? window : global;
      return t.__localeData__ ? t.__localeData__[e] : null;
    }

    return e;
  }

  function Qe(e, t) {
    return Ee(x(Se(), e), "LLLL", t);
  }

  function Ve(e, t) {
    return Ee(x(Se(), e), "LLL", t);
  }

  function Ue(e, t) {
    return Ee(T(Se(), e), "QQQ", t);
  }

  function $e(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        n = t.maxDate,
        a = t.excludeDates,
        o = t.includeDates,
        s = t.filterDate;
    return et(e, {
      minDate: r,
      maxDate: n
    }) || a && a.some(function (t) {
      return Re(e, t);
    }) || o && !o.some(function (t) {
      return Re(e, t);
    }) || s && !s(Se(e)) || !1;
  }

  function ze(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.excludeDates;
    return r && r.some(function (t) {
      return Re(e, t);
    }) || !1;
  }

  function Ge(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        n = t.maxDate,
        a = t.excludeDates,
        o = t.includeDates,
        s = t.filterDate;
    return et(e, {
      minDate: r,
      maxDate: n
    }) || a && a.some(function (t) {
      return qe(e, t);
    }) || o && !o.some(function (t) {
      return qe(e, t);
    }) || s && !s(Se(e)) || !1;
  }

  function Je(e, t, r, n) {
    var a = P(e),
        o = O(e),
        s = P(t),
        p = O(t),
        i = P(n);
    return a === s && a === i ? o <= r && r <= p : a < s ? i === a && o <= r || i === s && p >= r || i < s && i > a : void 0;
  }

  function Xe(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        n = t.maxDate,
        a = t.excludeDates,
        o = t.includeDates,
        s = t.filterDate;
    return et(e, {
      minDate: r,
      maxDate: n
    }) || a && a.some(function (t) {
      return We(e, t);
    }) || o && !o.some(function (t) {
      return We(e, t);
    }) || s && !s(Se(e)) || !1;
  }

  function Ze(e, t, r, n) {
    var a = P(e),
        o = S(e),
        s = P(t),
        p = S(t),
        i = P(n);
    return a === s && a === i ? o <= r && r <= p : a < s ? i === a && o <= r || i === s && p >= r || i < s && i > a : void 0;
  }

  function et(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        n = t.maxDate;
    return r && F(e, r) < 0 || n && F(e, n) > 0;
  }

  function tt(e, t) {
    for (var r = t.length, n = 0; n < r; n++) {
      if (g(t[n]) === g(e) && k(t[n]) === k(e)) return !0;
    }

    return !1;
  }

  function rt(e, t) {
    var r = t.minTime,
        n = t.maxTime;
    if (!r || !n) throw new Error("Both minTime and maxTime props required");
    var a,
        o = Se(),
        s = Y(N(o, k(e)), g(e)),
        p = Y(N(o, k(r)), g(r)),
        i = Y(N(o, k(n)), g(n));

    try {
      a = !re(s, {
        start: p,
        end: i
      });
    } catch (e) {
      a = !1;
    }

    return a;
  }

  function nt(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        n = t.includeDates,
        a = v(e, 1);
    return r && q(r, a) > 0 || n && n.every(function (e) {
      return q(e, a) > 0;
    }) || !1;
  }

  function at(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.maxDate,
        n = t.includeDates,
        a = d(e, 1);
    return r && q(a, r) > 0 || n && n.every(function (e) {
      return q(a, e) > 0;
    }) || !1;
  }

  function ot(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.minDate,
        n = t.includeDates,
        a = w(e, 1);
    return r && R(r, a) > 0 || n && n.every(function (e) {
      return R(e, a) > 0;
    }) || !1;
  }

  function st(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = t.maxDate,
        n = t.includeDates,
        a = u(e, 1);
    return r && R(a, r) > 0 || n && n.every(function (e) {
      return R(a, e) > 0;
    }) || !1;
  }

  function pt(e) {
    var t = e.minDate,
        r = e.includeDates;

    if (r && t) {
      var n = r.filter(function (e) {
        return F(e, t) >= 0;
      });
      return L(n);
    }

    return r ? L(r) : t;
  }

  function it(e) {
    var t = e.maxDate,
        r = e.includeDates;

    if (r && t) {
      var n = r.filter(function (e) {
        return F(e, t) <= 0;
      });
      return j(n);
    }

    return r ? j(r) : t;
  }

  function ct() {
    for (var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map(), n = 0, o = e.length; n < o; n++) {
      var s = e[n];

      if (a(s)) {
        var p = Ee(s, "MM.dd.yyyy"),
            i = r.get(p) || [];
        i.includes(t) || (i.push(t), r.set(p, i));
      } else if ("object" === ie(s)) {
        var c = Object.keys(s),
            l = c[0],
            d = s[c[0]];
        if ("string" == typeof l && d.constructor === Array) for (var u = 0, h = d.length; u < h; u++) {
          var f = Ee(d[u], "MM.dd.yyyy"),
              m = r.get(f) || [];
          m.includes(l) || (m.push(l), r.set(f, m));
        }
      }
    }

    return r;
  }

  function lt(e, t, r, n, a) {
    for (var o = a.length, s = [], c = 0; c < o; c++) {
      var l = p(i(e, g(a[c])), k(a[c])),
          d = p(e, (r + 1) * n);
      ee(l, t) && te(l, d) && s.push(a[c]);
    }

    return s;
  }

  function dt(e) {
    return e < 10 ? "0".concat(e) : "".concat(e);
  }

  function ut(e, t, r, n) {
    for (var a = [], o = 0; o < 2 * t + 1; o++) {
      var s = e + t - o,
          p = !0;
      r && (p = P(r) <= s), n && p && (p = P(n) >= s), p && a.push(s);
    }

    return a;
  }

  var ht = se(function (e) {
    ye(a, e);
    var r = ge(a);

    function a(e) {
      var n;
      ce(this, a), ue(De(n = r.call(this, e)), "renderOptions", function () {
        var e = n.props.year,
            r = n.state.yearsList.map(function (r) {
          return t.createElement("div", {
            className: e === r ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
            key: r,
            onClick: n.onChange.bind(De(n), r)
          }, e === r ? t.createElement("span", {
            className: "react-datepicker__year-option--selected"
          }, "✓") : "", r);
        }),
            a = n.props.minDate ? P(n.props.minDate) : null,
            o = n.props.maxDate ? P(n.props.maxDate) : null;
        return o && n.state.yearsList.find(function (e) {
          return e === o;
        }) || r.unshift(t.createElement("div", {
          className: "react-datepicker__year-option",
          key: "upcoming",
          onClick: n.incrementYears
        }, t.createElement("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
        }))), a && n.state.yearsList.find(function (e) {
          return e === a;
        }) || r.push(t.createElement("div", {
          className: "react-datepicker__year-option",
          key: "previous",
          onClick: n.decrementYears
        }, t.createElement("a", {
          className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
        }))), r;
      }), ue(De(n), "onChange", function (e) {
        n.props.onChange(e);
      }), ue(De(n), "handleClickOutside", function () {
        n.props.onCancel();
      }), ue(De(n), "shiftYears", function (e) {
        var t = n.state.yearsList.map(function (t) {
          return t + e;
        });
        n.setState({
          yearsList: t
        });
      }), ue(De(n), "incrementYears", function () {
        return n.shiftYears(1);
      }), ue(De(n), "decrementYears", function () {
        return n.shiftYears(-1);
      });
      var o = e.yearDropdownItemNumber,
          s = e.scrollableYearDropdown,
          p = o || (s ? 10 : 5);
      return n.state = {
        yearsList: ut(n.props.year, p, n.props.minDate, n.props.maxDate)
      }, n;
    }

    return de(a, [{
      key: "render",
      value: function value() {
        var e = n({
          "react-datepicker__year-dropdown": !0,
          "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
        });
        return t.createElement("div", {
          className: e
        }, this.renderOptions());
      }
    }]), a;
  }(t.Component)),
      ft = function (e) {
    ye(n, e);
    var r = ge(n);

    function n() {
      var e;
      ce(this, n);

      for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++) {
        o[s] = arguments[s];
      }

      return ue(De(e = r.call.apply(r, [this].concat(o))), "state", {
        dropdownVisible: !1
      }), ue(De(e), "renderSelectOptions", function () {
        for (var r = e.props.minDate ? P(e.props.minDate) : 1900, n = e.props.maxDate ? P(e.props.maxDate) : 2100, a = [], o = r; o <= n; o++) {
          a.push(t.createElement("option", {
            key: o,
            value: o
          }, o));
        }

        return a;
      }), ue(De(e), "onSelectChange", function (t) {
        e.onChange(t.target.value);
      }), ue(De(e), "renderSelectMode", function () {
        return t.createElement("select", {
          value: e.props.year,
          className: "react-datepicker__year-select",
          onChange: e.onSelectChange
        }, e.renderSelectOptions());
      }), ue(De(e), "renderReadView", function (r) {
        return t.createElement("div", {
          key: "read",
          style: {
            visibility: r ? "visible" : "hidden"
          },
          className: "react-datepicker__year-read-view",
          onClick: function onClick(t) {
            return e.toggleDropdown(t);
          }
        }, t.createElement("span", {
          className: "react-datepicker__year-read-view--down-arrow"
        }), t.createElement("span", {
          className: "react-datepicker__year-read-view--selected-year"
        }, e.props.year));
      }), ue(De(e), "renderDropdown", function () {
        return t.createElement(ht, {
          key: "dropdown",
          year: e.props.year,
          onChange: e.onChange,
          onCancel: e.toggleDropdown,
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          scrollableYearDropdown: e.props.scrollableYearDropdown,
          yearDropdownItemNumber: e.props.yearDropdownItemNumber
        });
      }), ue(De(e), "renderScrollMode", function () {
        var t = e.state.dropdownVisible,
            r = [e.renderReadView(!t)];
        return t && r.unshift(e.renderDropdown()), r;
      }), ue(De(e), "onChange", function (t) {
        e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
      }), ue(De(e), "toggleDropdown", function (t) {
        e.setState({
          dropdownVisible: !e.state.dropdownVisible
        }, function () {
          e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
        });
      }), ue(De(e), "handleYearChange", function (t, r) {
        e.onSelect(t, r), e.setOpen();
      }), ue(De(e), "onSelect", function (t, r) {
        e.props.onSelect && e.props.onSelect(t, r);
      }), ue(De(e), "setOpen", function () {
        e.props.setOpen && e.props.setOpen(!0);
      }), e;
    }

    return de(n, [{
      key: "render",
      value: function value() {
        var e;

        switch (this.props.dropdownMode) {
          case "scroll":
            e = this.renderScrollMode();
            break;

          case "select":
            e = this.renderSelectMode();
        }

        return t.createElement("div", {
          className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
        }, e);
      }
    }]), n;
  }(t.Component),
      mt = se(function (e) {
    ye(n, e);
    var r = ge(n);

    function n() {
      var e;
      ce(this, n);

      for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++) {
        o[s] = arguments[s];
      }

      return ue(De(e = r.call.apply(r, [this].concat(o))), "renderOptions", function () {
        return e.props.monthNames.map(function (r, n) {
          return t.createElement("div", {
            className: e.props.month === n ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
            key: r,
            onClick: e.onChange.bind(De(e), n)
          }, e.props.month === n ? t.createElement("span", {
            className: "react-datepicker__month-option--selected"
          }, "✓") : "", r);
        });
      }), ue(De(e), "onChange", function (t) {
        return e.props.onChange(t);
      }), ue(De(e), "handleClickOutside", function () {
        return e.props.onCancel();
      }), e;
    }

    return de(n, [{
      key: "render",
      value: function value() {
        return t.createElement("div", {
          className: "react-datepicker__month-dropdown"
        }, this.renderOptions());
      }
    }]), n;
  }(t.Component)),
      yt = function (e) {
    ye(n, e);
    var r = ge(n);

    function n() {
      var e;
      ce(this, n);

      for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++) {
        o[s] = arguments[s];
      }

      return ue(De(e = r.call.apply(r, [this].concat(o))), "state", {
        dropdownVisible: !1
      }), ue(De(e), "renderSelectOptions", function (e) {
        return e.map(function (e, r) {
          return t.createElement("option", {
            key: r,
            value: r
          }, e);
        });
      }), ue(De(e), "renderSelectMode", function (r) {
        return t.createElement("select", {
          value: e.props.month,
          className: "react-datepicker__month-select",
          onChange: function onChange(t) {
            return e.onChange(t.target.value);
          }
        }, e.renderSelectOptions(r));
      }), ue(De(e), "renderReadView", function (r, n) {
        return t.createElement("div", {
          key: "read",
          style: {
            visibility: r ? "visible" : "hidden"
          },
          className: "react-datepicker__month-read-view",
          onClick: e.toggleDropdown
        }, t.createElement("span", {
          className: "react-datepicker__month-read-view--down-arrow"
        }), t.createElement("span", {
          className: "react-datepicker__month-read-view--selected-month"
        }, n[e.props.month]));
      }), ue(De(e), "renderDropdown", function (r) {
        return t.createElement(mt, {
          key: "dropdown",
          month: e.props.month,
          monthNames: r,
          onChange: e.onChange,
          onCancel: e.toggleDropdown
        });
      }), ue(De(e), "renderScrollMode", function (t) {
        var r = e.state.dropdownVisible,
            n = [e.renderReadView(!r, t)];
        return r && n.unshift(e.renderDropdown(t)), n;
      }), ue(De(e), "onChange", function (t) {
        e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
      }), ue(De(e), "toggleDropdown", function () {
        return e.setState({
          dropdownVisible: !e.state.dropdownVisible
        });
      }), e;
    }

    return de(n, [{
      key: "render",
      value: function value() {
        var e,
            r = this,
            n = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (e) {
          return Ve(e, r.props.locale);
        } : function (e) {
          return Qe(e, r.props.locale);
        });

        switch (this.props.dropdownMode) {
          case "scroll":
            e = this.renderScrollMode(n);
            break;

          case "select":
            e = this.renderSelectMode(n);
        }

        return t.createElement("div", {
          className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
        }, e);
      }
    }]), n;
  }(t.Component);

  function vt(e, t) {
    for (var r = [], n = Le(e), a = Le(t); !ee(n, a);) {
      r.push(Se(n)), n = d(n, 1);
    }

    return r;
  }

  var wt = se(function (e) {
    ye(a, e);
    var r = ge(a);

    function a(e) {
      var n;
      return ce(this, a), ue(De(n = r.call(this, e)), "renderOptions", function () {
        return n.state.monthYearsList.map(function (e) {
          var r = M(e),
              a = Fe(n.props.date, e) && qe(n.props.date, e);
          return t.createElement("div", {
            className: a ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
            key: r,
            onClick: n.onChange.bind(De(n), r)
          }, a ? t.createElement("span", {
            className: "react-datepicker__month-year-option--selected"
          }, "✓") : "", Ee(e, n.props.dateFormat));
        });
      }), ue(De(n), "onChange", function (e) {
        return n.props.onChange(e);
      }), ue(De(n), "handleClickOutside", function () {
        n.props.onCancel();
      }), n.state = {
        monthYearsList: vt(n.props.minDate, n.props.maxDate)
      }, n;
    }

    return de(a, [{
      key: "render",
      value: function value() {
        var e = n({
          "react-datepicker__month-year-dropdown": !0,
          "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
        });
        return t.createElement("div", {
          className: e
        }, this.renderOptions());
      }
    }]), a;
  }(t.Component)),
      Dt = function (e) {
    ye(n, e);
    var r = ge(n);

    function n() {
      var e;
      ce(this, n);

      for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++) {
        o[s] = arguments[s];
      }

      return ue(De(e = r.call.apply(r, [this].concat(o))), "state", {
        dropdownVisible: !1
      }), ue(De(e), "renderSelectOptions", function () {
        for (var r = Le(e.props.minDate), n = Le(e.props.maxDate), a = []; !ee(r, n);) {
          var o = M(r);
          a.push(t.createElement("option", {
            key: o,
            value: o
          }, Ee(r, e.props.dateFormat, e.props.locale))), r = d(r, 1);
        }

        return a;
      }), ue(De(e), "onSelectChange", function (t) {
        e.onChange(t.target.value);
      }), ue(De(e), "renderSelectMode", function () {
        return t.createElement("select", {
          value: M(Le(e.props.date)),
          className: "react-datepicker__month-year-select",
          onChange: e.onSelectChange
        }, e.renderSelectOptions());
      }), ue(De(e), "renderReadView", function (r) {
        var n = Ee(e.props.date, e.props.dateFormat, e.props.locale);
        return t.createElement("div", {
          key: "read",
          style: {
            visibility: r ? "visible" : "hidden"
          },
          className: "react-datepicker__month-year-read-view",
          onClick: function onClick(t) {
            return e.toggleDropdown(t);
          }
        }, t.createElement("span", {
          className: "react-datepicker__month-year-read-view--down-arrow"
        }), t.createElement("span", {
          className: "react-datepicker__month-year-read-view--selected-month-year"
        }, n));
      }), ue(De(e), "renderDropdown", function () {
        return t.createElement(wt, {
          key: "dropdown",
          date: e.props.date,
          dateFormat: e.props.dateFormat,
          onChange: e.onChange,
          onCancel: e.toggleDropdown,
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown
        });
      }), ue(De(e), "renderScrollMode", function () {
        var t = e.state.dropdownVisible,
            r = [e.renderReadView(!t)];
        return t && r.unshift(e.renderDropdown()), r;
      }), ue(De(e), "onChange", function (t) {
        e.toggleDropdown();
        var r = Se(parseInt(t));
        Fe(e.props.date, r) && qe(e.props.date, r) || e.props.onChange(r);
      }), ue(De(e), "toggleDropdown", function () {
        return e.setState({
          dropdownVisible: !e.state.dropdownVisible
        });
      }), e;
    }

    return de(n, [{
      key: "render",
      value: function value() {
        var e;

        switch (this.props.dropdownMode) {
          case "scroll":
            e = this.renderScrollMode();
            break;

          case "select":
            e = this.renderSelectMode();
        }

        return t.createElement("div", {
          className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
        }, e);
      }
    }]), n;
  }(t.Component),
      kt = function (e) {
    ye(a, e);
    var r = ge(a);

    function a() {
      var e;
      ce(this, a);

      for (var o = arguments.length, s = new Array(o), p = 0; p < o; p++) {
        s[p] = arguments[p];
      }

      return ue(De(e = r.call.apply(r, [this].concat(s))), "dayEl", t.createRef()), ue(De(e), "handleClick", function (t) {
        !e.isDisabled() && e.props.onClick && e.props.onClick(t);
      }), ue(De(e), "handleMouseEnter", function (t) {
        !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
      }), ue(De(e), "handleOnKeyDown", function (t) {
        " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
      }), ue(De(e), "isSameDay", function (t) {
        return Re(e.props.day, t);
      }), ue(De(e), "isKeyboardSelected", function () {
        return !e.props.disabledKeyboardNavigation && !e.props.inline && !e.isSameDay(e.props.selected) && e.isSameDay(e.props.preSelection);
      }), ue(De(e), "isDisabled", function () {
        return $e(e.props.day, e.props);
      }), ue(De(e), "isExcluded", function () {
        return ze(e.props.day, e.props);
      }), ue(De(e), "getHighLightedClass", function (t) {
        var r = e.props,
            n = r.day,
            a = r.highlightDates;
        if (!a) return !1;
        var o = Ee(n, "MM.dd.yyyy");
        return a.get(o);
      }), ue(De(e), "isInRange", function () {
        var t = e.props,
            r = t.day,
            n = t.startDate,
            a = t.endDate;
        return !(!n || !a) && Be(r, n, a);
      }), ue(De(e), "isInSelectingRange", function () {
        var t = e.props,
            r = t.day,
            n = t.selectsStart,
            a = t.selectsEnd,
            o = t.selectingDate,
            s = t.startDate,
            p = t.endDate;
        return !(!n && !a || !o || e.isDisabled()) && (n && p && (te(o, p) || Ae(o, p)) ? Be(r, o, p) : !(!a || !s || !ee(o, s) && !Ae(o, s)) && Be(r, s, o));
      }), ue(De(e), "isSelectingRangeStart", function () {
        if (!e.isInSelectingRange()) return !1;
        var t = e.props,
            r = t.day,
            n = t.selectingDate,
            a = t.startDate;
        return Re(r, t.selectsStart ? n : a);
      }), ue(De(e), "isSelectingRangeEnd", function () {
        if (!e.isInSelectingRange()) return !1;
        var t = e.props,
            r = t.day,
            n = t.selectingDate,
            a = t.endDate;
        return Re(r, t.selectsEnd ? n : a);
      }), ue(De(e), "isRangeStart", function () {
        var t = e.props,
            r = t.day,
            n = t.startDate,
            a = t.endDate;
        return !(!n || !a) && Re(n, r);
      }), ue(De(e), "isRangeEnd", function () {
        var t = e.props,
            r = t.day,
            n = t.startDate,
            a = t.endDate;
        return !(!n || !a) && Re(a, r);
      }), ue(De(e), "isWeekend", function () {
        var t = b(e.props.day);
        return 0 === t || 6 === t;
      }), ue(De(e), "isOutsideMonth", function () {
        return void 0 !== e.props.month && e.props.month !== O(e.props.day);
      }), ue(De(e), "getClassNames", function (t) {
        var r = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
        return n("react-datepicker__day", r, "react-datepicker__day--" + xe(e.props.day), {
          "react-datepicker__day--disabled": e.isDisabled(),
          "react-datepicker__day--excluded": e.isExcluded(),
          "react-datepicker__day--selected": e.isSameDay(e.props.selected),
          "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
          "react-datepicker__day--range-start": e.isRangeStart(),
          "react-datepicker__day--range-end": e.isRangeEnd(),
          "react-datepicker__day--in-range": e.isInRange(),
          "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
          "react-datepicker__day--today": e.isSameDay(Se()),
          "react-datepicker__day--weekend": e.isWeekend(),
          "react-datepicker__day--outside-month": e.isOutsideMonth()
        }, e.getHighLightedClass("react-datepicker__day--highlighted"));
      }), ue(De(e), "getAriaLabel", function () {
        var t = e.props,
            r = t.day,
            n = t.ariaLabelPrefixWhenEnabled,
            a = void 0 === n ? "Choose" : n,
            o = t.ariaLabelPrefixWhenDisabled,
            s = void 0 === o ? "Not available" : o,
            p = e.isDisabled() || e.isExcluded() ? s : a;
        return "".concat(p, " ").concat(Ee(r, "PPPP"));
      }), ue(De(e), "getTabIndex", function (t, r) {
        var n = t || e.props.selected,
            a = r || e.props.preSelection;
        return e.isKeyboardSelected() || e.isSameDay(n) && Re(a, n) ? 0 : -1;
      }), ue(De(e), "handleFocusDay", function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = !1;
        0 === e.getTabIndex() && !t.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (r = !0)), r && e.dayEl.current.focus();
      }), ue(De(e), "render", function () {
        return t.createElement("div", {
          ref: e.dayEl,
          className: e.getClassNames(e.props.day),
          onKeyDown: e.handleOnKeyDown,
          onClick: e.handleClick,
          onMouseEnter: e.handleMouseEnter,
          tabIndex: e.getTabIndex(),
          "aria-label": e.getAriaLabel(),
          role: "button",
          "aria-disabled": e.isDisabled()
        }, e.props.renderDayContents ? e.props.renderDayContents(C(e.props.day), e.props.day) : C(e.props.day));
      }), e;
    }

    return de(a, [{
      key: "componentDidMount",
      value: function value() {
        this.handleFocusDay();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        this.handleFocusDay(e);
      }
    }]), a;
  }(t.Component),
      gt = function (e) {
    ye(a, e);
    var r = ge(a);

    function a() {
      var e;
      ce(this, a);

      for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) {
        n[o] = arguments[o];
      }

      return ue(De(e = r.call.apply(r, [this].concat(n))), "handleClick", function (t) {
        e.props.onClick && e.props.onClick(t);
      }), e;
    }

    return de(a, [{
      key: "render",
      value: function value() {
        var e = this.props,
            r = e.weekNumber,
            a = e.ariaLabelPrefix,
            o = void 0 === a ? "week " : a,
            s = {
          "react-datepicker__week-number": !0,
          "react-datepicker__week-number--clickable": !!e.onClick
        };
        return t.createElement("div", {
          className: n(s),
          "aria-label": "".concat(o, " ").concat(this.props.weekNumber),
          onClick: this.handleClick
        }, r);
      }
    }]), a;
  }(t.Component),
      bt = function (e) {
    ye(n, e);
    var r = ge(n);

    function n() {
      var e;
      ce(this, n);

      for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++) {
        o[s] = arguments[s];
      }

      return ue(De(e = r.call.apply(r, [this].concat(o))), "handleDayClick", function (t, r) {
        e.props.onDayClick && e.props.onDayClick(t, r);
      }), ue(De(e), "handleDayMouseEnter", function (t) {
        e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
      }), ue(De(e), "handleWeekClick", function (t, r, n) {
        "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, n), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
      }), ue(De(e), "formatWeekNumber", function (t) {
        return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : Ye(t, e.props.locale);
      }), ue(De(e), "renderDays", function () {
        var r = Ie(e.props.day, e.props.locale),
            n = [],
            a = e.formatWeekNumber(r);

        if (e.props.showWeekNumber) {
          var o = e.props.onWeekSelect ? e.handleWeekClick.bind(De(e), r, a) : void 0;
          n.push(t.createElement(gt, {
            key: "W",
            weekNumber: a,
            onClick: o,
            ariaLabelPrefix: e.props.ariaLabelPrefix
          }));
        }

        return n.concat([0, 1, 2, 3, 4, 5, 6].map(function (n) {
          var a = c(r, n);
          return t.createElement(kt, {
            ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
            ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
            key: a.valueOf(),
            day: a,
            month: e.props.month,
            onClick: e.handleDayClick.bind(De(e), a),
            onMouseEnter: e.handleDayMouseEnter.bind(De(e), a),
            minDate: e.props.minDate,
            maxDate: e.props.maxDate,
            excludeDates: e.props.excludeDates,
            includeDates: e.props.includeDates,
            inline: e.props.inline,
            highlightDates: e.props.highlightDates,
            selectingDate: e.props.selectingDate,
            filterDate: e.props.filterDate,
            preSelection: e.props.preSelection,
            selected: e.props.selected,
            selectsStart: e.props.selectsStart,
            selectsEnd: e.props.selectsEnd,
            startDate: e.props.startDate,
            endDate: e.props.endDate,
            dayClassName: e.props.dayClassName,
            renderDayContents: e.props.renderDayContents,
            disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
            handleOnKeyDown: e.props.handleOnKeyDown,
            isInputFocused: e.props.isInputFocused,
            containerRef: e.props.containerRef
          });
        }));
      }), e;
    }

    return de(n, [{
      key: "render",
      value: function value() {
        return t.createElement("div", {
          className: "react-datepicker__week"
        }, this.renderDays());
      }
    }], [{
      key: "defaultProps",
      get: function get() {
        return {
          shouldCloseOnSelect: !0
        };
      }
    }]), n;
  }(t.Component),
      Ct = function (e) {
    ye(a, e);
    var r = ge(a);

    function a() {
      var e;
      ce(this, a);

      for (var o = arguments.length, s = new Array(o), p = 0; p < o; p++) {
        s[p] = arguments[p];
      }

      return ue(De(e = r.call.apply(r, [this].concat(s))), "handleDayClick", function (t, r) {
        e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
      }), ue(De(e), "handleDayMouseEnter", function (t) {
        e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
      }), ue(De(e), "handleMouseLeave", function () {
        e.props.onMouseLeave && e.props.onMouseLeave();
      }), ue(De(e), "isRangeStartMonth", function (t) {
        var r = e.props,
            n = r.day,
            a = r.startDate,
            o = r.endDate;
        return !(!a || !o) && qe(x(n, t), a);
      }), ue(De(e), "isRangeStartQuarter", function (t) {
        var r = e.props,
            n = r.day,
            a = r.startDate,
            o = r.endDate;
        return !(!a || !o) && We(T(n, t), a);
      }), ue(De(e), "isRangeEndMonth", function (t) {
        var r = e.props,
            n = r.day,
            a = r.startDate,
            o = r.endDate;
        return !(!a || !o) && qe(x(n, t), o);
      }), ue(De(e), "isRangeEndQuarter", function (t) {
        var r = e.props,
            n = r.day,
            a = r.startDate,
            o = r.endDate;
        return !(!a || !o) && We(T(n, t), o);
      }), ue(De(e), "isWeekInMonth", function (t) {
        var r = e.props.day,
            n = c(t, 6);
        return qe(t, r) || qe(n, r);
      }), ue(De(e), "renderWeeks", function () {
        for (var r = [], n = e.props.fixedHeight, a = Ie(Le(e.props.day), e.props.locale), o = 0, s = !1; r.push(t.createElement(bt, {
          ariaLabelPrefix: e.props.weekAriaLabelPrefix,
          chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
          disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
          key: o,
          day: a,
          month: O(e.props.day),
          onDayClick: e.handleDayClick,
          onDayMouseEnter: e.handleDayMouseEnter,
          onWeekSelect: e.props.onWeekSelect,
          formatWeekNumber: e.props.formatWeekNumber,
          locale: e.props.locale,
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          includeDates: e.props.includeDates,
          inline: e.props.inline,
          highlightDates: e.props.highlightDates,
          selectingDate: e.props.selectingDate,
          filterDate: e.props.filterDate,
          preSelection: e.props.preSelection,
          selected: e.props.selected,
          selectsStart: e.props.selectsStart,
          selectsEnd: e.props.selectsEnd,
          showWeekNumber: e.props.showWeekNumbers,
          startDate: e.props.startDate,
          endDate: e.props.endDate,
          dayClassName: e.props.dayClassName,
          setOpen: e.props.setOpen,
          shouldCloseOnSelect: e.props.shouldCloseOnSelect,
          disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
          renderDayContents: e.props.renderDayContents,
          handleOnKeyDown: e.props.handleOnKeyDown,
          isInputFocused: e.props.isInputFocused,
          containerRef: e.props.containerRef
        })), !s;) {
          o++, a = l(a, 1);
          var p = n && o >= 6,
              i = !n && !e.isWeekInMonth(a);

          if (p || i) {
            if (!e.props.peekNextMonth) break;
            s = !0;
          }
        }

        return r;
      }), ue(De(e), "onMonthClick", function (t, r) {
        e.handleDayClick(Le(x(e.props.day, r)), t);
      }), ue(De(e), "onQuarterClick", function (t, r) {
        e.handleDayClick(je(T(e.props.day, r)), t);
      }), ue(De(e), "getMonthClassNames", function (t) {
        var r = e.props,
            a = r.day,
            o = r.startDate,
            s = r.endDate,
            p = r.selected,
            i = r.minDate,
            c = r.maxDate;
        return n("react-datepicker__month-text", "react-datepicker__month-".concat(t), {
          "react-datepicker__month--disabled": (i || c) && Ge(x(a, t), e.props),
          "react-datepicker__month--selected": O(a) === t && P(a) === P(p),
          "react-datepicker__month--in-range": Je(o, s, t, a),
          "react-datepicker__month--range-start": e.isRangeStartMonth(t),
          "react-datepicker__month--range-end": e.isRangeEndMonth(t)
        });
      }), ue(De(e), "getQuarterClassNames", function (t) {
        var r = e.props,
            a = r.day,
            o = r.startDate,
            s = r.endDate,
            p = r.selected,
            i = r.minDate,
            c = r.maxDate;
        return n("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
          "react-datepicker__quarter--disabled": (i || c) && Xe(T(a, t), e.props),
          "react-datepicker__quarter--selected": S(a) === t && P(a) === P(p),
          "react-datepicker__quarter--in-range": Ze(o, s, t, a),
          "react-datepicker__quarter--range-start": e.isRangeStartQuarter(t),
          "react-datepicker__quarter--range-end": e.isRangeEndQuarter(t)
        });
      }), ue(De(e), "renderMonths", function () {
        var r = e.props,
            n = r.showFullMonthYearPicker,
            a = r.locale;
        return [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11]].map(function (r, o) {
          return t.createElement("div", {
            className: "react-datepicker__month-wrapper",
            key: o
          }, r.map(function (r, o) {
            return t.createElement("div", {
              key: o,
              onClick: function onClick(t) {
                e.onMonthClick(t, r);
              },
              className: e.getMonthClassNames(r)
            }, n ? Qe(r, a) : Ve(r, a));
          }));
        });
      }), ue(De(e), "renderQuarters", function () {
        return t.createElement("div", {
          className: "react-datepicker__quarter-wrapper"
        }, [1, 2, 3, 4].map(function (r, n) {
          return t.createElement("div", {
            key: n,
            onClick: function onClick(t) {
              e.onQuarterClick(t, r);
            },
            className: e.getQuarterClassNames(r)
          }, Ue(r, e.props.locale));
        }));
      }), ue(De(e), "getClassNames", function () {
        var t = e.props,
            r = t.selectingDate,
            a = t.selectsStart,
            o = t.selectsEnd,
            s = t.showMonthYearPicker,
            p = t.showQuarterYearPicker;
        return n("react-datepicker__month", {
          "react-datepicker__month--selecting-range": r && (a || o)
        }, {
          "react-datepicker__monthPicker": s
        }, {
          "react-datepicker__quarterPicker": p
        });
      }), e;
    }

    return de(a, [{
      key: "render",
      value: function value() {
        var e = this.props,
            r = e.showMonthYearPicker,
            n = e.showQuarterYearPicker,
            a = e.day,
            o = e.ariaLabelPrefix,
            s = void 0 === o ? "month " : o;
        return t.createElement("div", {
          className: this.getClassNames(),
          onMouseLeave: this.handleMouseLeave,
          "aria-label": "".concat(s, " ").concat(Ee(a, "yyyy-MM"))
        }, r ? this.renderMonths() : n ? this.renderQuarters() : this.renderWeeks());
      }
    }]), a;
  }(t.Component),
      _t = function (e) {
    ye(n, e);
    var r = ge(n);

    function n() {
      var e;
      ce(this, n);

      for (var a = arguments.length, o = new Array(a), s = 0; s < a; s++) {
        o[s] = arguments[s];
      }

      return ue(De(e = r.call.apply(r, [this].concat(o))), "state", {
        height: null
      }), ue(De(e), "handleClick", function (t) {
        (e.props.minTime || e.props.maxTime) && rt(t, e.props) || e.props.excludeTimes && tt(t, e.props.excludeTimes) || e.props.includeTimes && !tt(t, e.props.includeTimes) || e.props.onChange(t);
      }), ue(De(e), "liClasses", function (t, r, n) {
        var a = ["react-datepicker__time-list-item", e.props.timeClassName ? e.props.timeClassName(t, r, n) : void 0];
        return e.props.selected && r === g(t) && n === k(t) && a.push("react-datepicker__time-list-item--selected"), ((e.props.minTime || e.props.maxTime) && rt(t, e.props) || e.props.excludeTimes && tt(t, e.props.excludeTimes) || e.props.includeTimes && !tt(t, e.props.includeTimes)) && a.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * g(t) + k(t)) % e.props.intervals != 0 && a.push("react-datepicker__time-list-item--injected"), a.join(" ");
      }), ue(De(e), "renderTimes", function () {
        for (var r = [], n = e.props.format ? e.props.format : "p", a = e.props.intervals, o = e.props.selected || e.props.openToDate || Se(), s = g(o), i = k(o), c = Te(Se()), l = 1440 / a, d = e.props.injectTimes && e.props.injectTimes.sort(function (e, t) {
          return e - t;
        }), u = 0; u < l; u++) {
          var h = p(c, u * a);

          if (r.push(h), d) {
            var f = lt(c, h, u, a, d);
            r = r.concat(f);
          }
        }

        return r.map(function (r, a) {
          return t.createElement("li", {
            key: a,
            onClick: e.handleClick.bind(De(e), r),
            className: e.liClasses(r, s, i),
            ref: function ref(t) {
              s === g(r) && i >= k(r) && (e.centerLi = t);
            }
          }, Ee(r, n, e.props.locale));
        });
      }), e;
    }

    return de(n, [{
      key: "componentDidMount",
      value: function value() {
        this.list.scrollTop = n.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
          height: this.props.monthRef.clientHeight - this.header.clientHeight
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            r = this.state.height;
        return t.createElement("div", {
          className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
        }, t.createElement("div", {
          className: "react-datepicker__header react-datepicker__header--time",
          ref: function ref(t) {
            e.header = t;
          }
        }, t.createElement("div", {
          className: "react-datepicker-time__header"
        }, this.props.timeCaption)), t.createElement("div", {
          className: "react-datepicker__time"
        }, t.createElement("div", {
          className: "react-datepicker__time-box"
        }, t.createElement("ul", {
          className: "react-datepicker__time-list",
          ref: function ref(t) {
            e.list = t;
          },
          style: r ? {
            height: r
          } : {}
        }, this.renderTimes()))));
      }
    }], [{
      key: "defaultProps",
      get: function get() {
        return {
          intervals: 30,
          onTimeChange: function onTimeChange() {},
          todayButton: null,
          timeCaption: "Time"
        };
      }
    }]), n;
  }(t.Component);

  ue(_t, "calcCenterPosition", function (e, t) {
    return t.offsetTop - (e / 2 - t.clientHeight / 2);
  });

  var Ot = function (e) {
    ye(n, e);
    var r = ge(n);

    function n(e) {
      var t;
      return ce(this, n), ue(De(t = r.call(this, e)), "handleYearClick", function (e, r) {
        t.props.onDayClick && t.props.onDayClick(e, r);
      }), ue(De(t), "onYearClick", function (e, r) {
        var n;
        t.handleYearClick((n = I(t.props.date, r), Q(n)), e);
      }), t;
    }

    return de(n, [{
      key: "render",
      value: function value() {
        for (var e = this, r = [], n = this.props.date, a = function a(n, _a) {
          r.push(t.createElement("div", {
            onClick: function onClick(t) {
              e.onYearClick(t, n);
            },
            className: "react-datepicker__year-container-text",
            key: n
          }, n));
        }, o = P(n) - 11, s = 0; o <= P(n); o++, s++) {
          a(o);
        }

        return t.createElement("div", {
          className: "react-datepicker__year-container"
        }, r);
      }
    }]), n;
  }(t.Component),
      St = function (e) {
    ye(n, e);
    var r = ge(n);

    function n(e) {
      var a;
      return ce(this, n), ue(De(a = r.call(this, e)), "onTimeChange", function (e) {
        a.setState({
          time: e
        });
        var t = new Date();
        t.setHours(e.split(":")[0]), t.setMinutes(e.split(":")[1]), a.props.onChange(t);
      }), ue(De(a), "renderTimeInput", function () {
        var e = a.state.time,
            r = a.props,
            n = r.timeString,
            o = r.customTimeInput;
        return o ? t.cloneElement(o, {
          value: e,
          onChange: a.onTimeChange
        }) : t.createElement("input", {
          type: "time",
          className: "react-datepicker-time__input",
          placeholder: "Time",
          name: "time-input",
          required: !0,
          value: e,
          onChange: function onChange(e) {
            a.onTimeChange(e.target.value || n);
          }
        });
      }), a.state = {
        time: a.props.timeString
      }, a;
    }

    return de(n, [{
      key: "render",
      value: function value() {
        return t.createElement("div", {
          className: "react-datepicker__input-time-container"
        }, t.createElement("div", {
          className: "react-datepicker-time__caption"
        }, this.props.timeInputLabel), t.createElement("div", {
          className: "react-datepicker-time__input-container"
        }, t.createElement("div", {
          className: "react-datepicker-time__input"
        }, this.renderTimeInput())));
      }
    }]), n;
  }(t.Component);

  function Pt(e) {
    var r = e.className,
        n = e.children,
        a = e.showPopperArrow,
        o = e.arrowProps,
        s = void 0 === o ? {} : o;
    return t.createElement("div", {
      className: r
    }, a && t.createElement("div", he({
      className: "react-datepicker__triangle"
    }, s)), n);
  }

  var Mt = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"],
      Et = function (e) {
    ye(a, e);
    var r = ge(a);

    function a(e) {
      var o;
      return ce(this, a), ue(De(o = r.call(this, e)), "handleClickOutside", function (e) {
        o.props.onClickOutside(e);
      }), ue(De(o), "setClickOutsideRef", function () {
        return o.containerRef.current;
      }), ue(De(o), "handleDropdownFocus", function (e) {
        (function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = (e.className || "").split(/\s+/);
          return Mt.some(function (e) {
            return t.indexOf(e) >= 0;
          });
        })(e.target) && o.props.onDropdownFocus();
      }), ue(De(o), "getDateInView", function () {
        var e = o.props,
            t = e.preSelection,
            r = e.selected,
            n = e.openToDate,
            a = pt(o.props),
            s = it(o.props),
            p = Se(),
            i = n || r || t;
        return i || (a && te(p, a) ? a : s && ee(p, s) ? s : p);
      }), ue(De(o), "increaseMonth", function () {
        o.setState(function (e) {
          var t = e.date;
          return {
            date: d(t, 1)
          };
        }, function () {
          return o.handleMonthChange(o.state.date);
        });
      }), ue(De(o), "decreaseMonth", function () {
        o.setState(function (e) {
          var t = e.date;
          return {
            date: v(t, 1)
          };
        }, function () {
          return o.handleMonthChange(o.state.date);
        });
      }), ue(De(o), "handleDayClick", function (e, t, r) {
        return o.props.onSelect(e, t, r);
      }), ue(De(o), "handleDayMouseEnter", function (e) {
        o.setState({
          selectingDate: e
        }), o.props.onDayMouseEnter && o.props.onDayMouseEnter(e);
      }), ue(De(o), "handleMonthMouseLeave", function () {
        o.setState({
          selectingDate: null
        }), o.props.onMonthMouseLeave && o.props.onMonthMouseLeave();
      }), ue(De(o), "handleYearChange", function (e) {
        o.props.onYearChange && o.props.onYearChange(e);
      }), ue(De(o), "handleMonthChange", function (e) {
        o.props.onMonthChange && o.props.onMonthChange(e), o.props.adjustDateOnChange && (o.props.onSelect && o.props.onSelect(e), o.props.setOpen && o.props.setOpen(!0)), o.props.setPreSelection && o.props.setPreSelection(e);
      }), ue(De(o), "handleMonthYearChange", function (e) {
        o.handleYearChange(e), o.handleMonthChange(e);
      }), ue(De(o), "changeYear", function (e) {
        o.setState(function (t) {
          var r = t.date;
          return {
            date: I(r, e)
          };
        }, function () {
          return o.handleYearChange(o.state.date);
        });
      }), ue(De(o), "changeMonth", function (e) {
        o.setState(function (t) {
          var r = t.date;
          return {
            date: x(r, e)
          };
        }, function () {
          return o.handleMonthChange(o.state.date);
        });
      }), ue(De(o), "changeMonthYear", function (e) {
        o.setState(function (t) {
          var r = t.date;
          return {
            date: I(x(r, O(e)), P(e))
          };
        }, function () {
          return o.handleMonthYearChange(o.state.date);
        });
      }), ue(De(o), "header", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : o.state.date,
            r = Ie(e, o.props.locale),
            a = [];
        return o.props.showWeekNumbers && a.push(t.createElement("div", {
          key: "W",
          className: "react-datepicker__day-name"
        }, o.props.weekLabel || "#")), a.concat([0, 1, 2, 3, 4, 5, 6].map(function (e) {
          var a = c(r, e),
              s = o.formatWeekday(a, o.props.locale),
              p = o.props.weekDayClassName ? o.props.weekDayClassName(a) : void 0;
          return t.createElement("div", {
            key: e,
            className: n("react-datepicker__day-name", p)
          }, s);
        }));
      }), ue(De(o), "formatWeekday", function (e, t) {
        return o.props.formatWeekDay ? function (e, t, r) {
          return t(Ee(e, "EEEE", r));
        }(e, o.props.formatWeekDay, t) : o.props.useWeekdaysShort ? function (e, t) {
          return Ee(e, "EEE", t);
        }(e, t) : function (e, t) {
          return Ee(e, "EEEEEE", t);
        }(e, t);
      }), ue(De(o), "decreaseYear", function () {
        o.setState(function (e) {
          var t = e.date;
          return {
            date: w(t, o.props.showYearPicker ? 11 : 1)
          };
        }, function () {
          return o.handleYearChange(o.state.date);
        });
      }), ue(De(o), "renderPreviousButton", function () {
        if (!o.props.renderCustomHeader) {
          var e = o.props.showMonthYearPicker ? ot(o.state.date, o.props) : nt(o.state.date, o.props);

          if ((o.props.forceShowMonthNavigation || o.props.showDisabledMonthNavigation || !e) && !o.props.showTimeSelectOnly) {
            var r = ["react-datepicker__navigation", "react-datepicker__navigation--previous"],
                n = o.decreaseMonth;
            (o.props.showMonthYearPicker || o.props.showQuarterYearPicker || o.props.showYearPicker) && (n = o.decreaseYear), e && o.props.showDisabledMonthNavigation && (r.push("react-datepicker__navigation--previous--disabled"), n = null);
            var a = o.props.showMonthYearPicker || o.props.showQuarterYearPicker,
                s = o.props,
                p = s.previousMonthAriaLabel,
                i = void 0 === p ? "Previous Month" : p,
                c = s.previousYearAriaLabel,
                l = void 0 === c ? "Previous Year" : c;
            return t.createElement("button", {
              type: "button",
              className: r.join(" "),
              onClick: n,
              "aria-label": a ? l : i
            }, a ? o.props.previousYearButtonLabel : o.props.previousMonthButtonLabel);
          }
        }
      }), ue(De(o), "increaseYear", function () {
        o.setState(function (e) {
          var t = e.date;
          return {
            date: u(t, o.props.showYearPicker ? 11 : 1)
          };
        }, function () {
          return o.handleYearChange(o.state.date);
        });
      }), ue(De(o), "renderNextButton", function () {
        if (!o.props.renderCustomHeader) {
          var e = o.props.showMonthYearPicker ? st(o.state.date, o.props) : at(o.state.date, o.props);

          if ((o.props.forceShowMonthNavigation || o.props.showDisabledMonthNavigation || !e) && !o.props.showTimeSelectOnly) {
            var r = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
            o.props.showTimeSelect && r.push("react-datepicker__navigation--next--with-time"), o.props.todayButton && r.push("react-datepicker__navigation--next--with-today-button");
            var n = o.increaseMonth;
            (o.props.showMonthYearPicker || o.props.showQuarterYearPicker || o.props.showYearPicker) && (n = o.increaseYear), e && o.props.showDisabledMonthNavigation && (r.push("react-datepicker__navigation--next--disabled"), n = null);
            var a = o.props.showMonthYearPicker || o.props.showQuarterYearPicker,
                s = o.props,
                p = s.nextMonthAriaLabel,
                i = void 0 === p ? "Next Month" : p,
                c = s.nextYearAriaLabel,
                l = void 0 === c ? "Next Year" : c;
            return t.createElement("button", {
              type: "button",
              className: r.join(" "),
              onClick: n,
              "aria-label": a ? l : i
            }, a ? o.props.nextYearButtonLabel : o.props.nextMonthButtonLabel);
          }
        }
      }), ue(De(o), "renderCurrentMonth", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : o.state.date,
            r = ["react-datepicker__current-month"];
        return o.props.showYearDropdown && r.push("react-datepicker__current-month--hasYearDropdown"), o.props.showMonthDropdown && r.push("react-datepicker__current-month--hasMonthDropdown"), o.props.showMonthYearDropdown && r.push("react-datepicker__current-month--hasMonthYearDropdown"), t.createElement("div", {
          className: r.join(" ")
        }, Ee(e, o.props.dateFormat, o.props.locale));
      }), ue(De(o), "renderYearDropdown", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        if (o.props.showYearDropdown && !e) return t.createElement(ft, {
          adjustDateOnChange: o.props.adjustDateOnChange,
          date: o.state.date,
          onSelect: o.props.onSelect,
          setOpen: o.props.setOpen,
          dropdownMode: o.props.dropdownMode,
          onChange: o.changeYear,
          minDate: o.props.minDate,
          maxDate: o.props.maxDate,
          year: P(o.state.date),
          scrollableYearDropdown: o.props.scrollableYearDropdown,
          yearDropdownItemNumber: o.props.yearDropdownItemNumber
        });
      }), ue(De(o), "renderMonthDropdown", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        if (o.props.showMonthDropdown && !e) return t.createElement(yt, {
          dropdownMode: o.props.dropdownMode,
          locale: o.props.locale,
          onChange: o.changeMonth,
          month: O(o.state.date),
          useShortMonthInDropdown: o.props.useShortMonthInDropdown
        });
      }), ue(De(o), "renderMonthYearDropdown", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
        if (o.props.showMonthYearDropdown && !e) return t.createElement(Dt, {
          dropdownMode: o.props.dropdownMode,
          locale: o.props.locale,
          dateFormat: o.props.dateFormat,
          onChange: o.changeMonthYear,
          minDate: o.props.minDate,
          maxDate: o.props.maxDate,
          date: o.state.date,
          scrollableMonthYearDropdown: o.props.scrollableMonthYearDropdown
        });
      }), ue(De(o), "renderTodayButton", function () {
        if (o.props.todayButton && !o.props.showTimeSelectOnly) return t.createElement("div", {
          className: "react-datepicker__today-button",
          onClick: function onClick(e) {
            return o.props.onSelect(A(Se()), e);
          }
        }, o.props.todayButton);
      }), ue(De(o), "renderDefaultHeader", function (e) {
        var r = e.monthDate,
            n = e.i;
        return t.createElement("div", {
          className: "react-datepicker__header"
        }, o.renderCurrentMonth(r), t.createElement("div", {
          className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(o.props.dropdownMode),
          onFocus: o.handleDropdownFocus
        }, o.renderMonthDropdown(0 !== n), o.renderMonthYearDropdown(0 !== n), o.renderYearDropdown(0 !== n)), t.createElement("div", {
          className: "react-datepicker__day-names"
        }, o.header(r)));
      }), ue(De(o), "renderCustomHeader", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            r = e.monthDate,
            n = e.i;
        if (0 !== n && void 0 !== n) return null;
        var a = nt(o.state.date, o.props),
            s = at(o.state.date, o.props),
            p = ot(o.state.date, o.props),
            i = st(o.state.date, o.props),
            c = !o.props.showMonthYearPicker && !o.props.showQuarterYearPicker && !o.props.showYearPicker;
        return t.createElement("div", {
          className: "react-datepicker__header react-datepicker__header--custom",
          onFocus: o.props.onDropdownFocus
        }, o.props.renderCustomHeader(me(me({}, o.state), {}, {
          changeMonth: o.changeMonth,
          changeYear: o.changeYear,
          decreaseMonth: o.decreaseMonth,
          increaseMonth: o.increaseMonth,
          decreaseYear: o.decreaseYear,
          increaseYear: o.increaseYear,
          prevMonthButtonDisabled: a,
          nextMonthButtonDisabled: s,
          prevYearButtonDisabled: p,
          nextYearButtonDisabled: i
        })), c && t.createElement("div", {
          className: "react-datepicker__day-names"
        }, o.header(r)));
      }), ue(De(o), "renderYearHeader", function () {
        return t.createElement("div", {
          className: "react-datepicker__header react-datepicker-year-header"
        }, o.props.showYearPicker ? "".concat(P(o.state.date) - 11, " - ").concat(P(o.state.date)) : P(o.state.date));
      }), ue(De(o), "renderHeader", function (e) {
        switch (!0) {
          case void 0 !== o.props.renderCustomHeader:
            return o.renderCustomHeader(e);

          case o.props.showMonthYearPicker || o.props.showQuarterYearPicker || o.props.showYearPicker:
            return o.renderYearHeader(e);

          default:
            return o.renderDefaultHeader(e);
        }
      }), ue(De(o), "renderMonths", function () {
        if (!o.props.showTimeSelectOnly && !o.props.showYearPicker) {
          for (var e = [], r = o.props.showPreviousMonths ? o.props.monthsShown - 1 : 0, n = v(o.state.date, r), a = 0; a < o.props.monthsShown; ++a) {
            var s = a - o.props.monthSelectedIn,
                p = d(n, s),
                i = "month-".concat(a);
            e.push(t.createElement("div", {
              key: i,
              ref: function ref(e) {
                o.monthContainer = e;
              },
              className: "react-datepicker__month-container"
            }, o.renderHeader({
              monthDate: p,
              i: a
            }), t.createElement(Ct, {
              chooseDayAriaLabelPrefix: o.props.chooseDayAriaLabelPrefix,
              disabledDayAriaLabelPrefix: o.props.disabledDayAriaLabelPrefix,
              weekAriaLabelPrefix: o.props.weekAriaLabelPrefix,
              onChange: o.changeMonthYear,
              day: p,
              dayClassName: o.props.dayClassName,
              monthClassName: o.props.monthClassName,
              onDayClick: o.handleDayClick,
              handleOnKeyDown: o.props.handleOnKeyDown,
              onDayMouseEnter: o.handleDayMouseEnter,
              onMouseLeave: o.handleMonthMouseLeave,
              onWeekSelect: o.props.onWeekSelect,
              orderInDisplay: a,
              formatWeekNumber: o.props.formatWeekNumber,
              locale: o.props.locale,
              minDate: o.props.minDate,
              maxDate: o.props.maxDate,
              excludeDates: o.props.excludeDates,
              highlightDates: o.props.highlightDates,
              selectingDate: o.state.selectingDate,
              includeDates: o.props.includeDates,
              inline: o.props.inline,
              fixedHeight: o.props.fixedHeight,
              filterDate: o.props.filterDate,
              preSelection: o.props.preSelection,
              selected: o.props.selected,
              selectsStart: o.props.selectsStart,
              selectsEnd: o.props.selectsEnd,
              showWeekNumbers: o.props.showWeekNumbers,
              startDate: o.props.startDate,
              endDate: o.props.endDate,
              peekNextMonth: o.props.peekNextMonth,
              setOpen: o.props.setOpen,
              shouldCloseOnSelect: o.props.shouldCloseOnSelect,
              renderDayContents: o.props.renderDayContents,
              disabledKeyboardNavigation: o.props.disabledKeyboardNavigation,
              showMonthYearPicker: o.props.showMonthYearPicker,
              showFullMonthYearPicker: o.props.showFullMonthYearPicker,
              showYearPicker: o.props.showYearPicker,
              showQuarterYearPicker: o.props.showQuarterYearPicker,
              isInputFocused: o.props.isInputFocused,
              containerRef: o.containerRef
            })));
          }

          return e;
        }
      }), ue(De(o), "renderYears", function () {
        if (!o.props.showTimeSelectOnly) return o.props.showYearPicker ? t.createElement("div", {
          className: "react-datepicker__year"
        }, o.renderHeader(), t.createElement(Ot, {
          onDayClick: o.handleDayClick,
          date: o.state.date
        })) : void 0;
      }), ue(De(o), "renderTimeSection", function () {
        if (o.props.showTimeSelect && (o.state.monthContainer || o.props.showTimeSelectOnly)) return t.createElement(_t, {
          selected: o.props.selected,
          openToDate: o.props.openToDate,
          onChange: o.props.onTimeChange,
          timeClassName: o.props.timeClassName,
          format: o.props.timeFormat,
          includeTimes: o.props.includeTimes,
          intervals: o.props.timeIntervals,
          minTime: o.props.minTime,
          maxTime: o.props.maxTime,
          excludeTimes: o.props.excludeTimes,
          timeCaption: o.props.timeCaption,
          todayButton: o.props.todayButton,
          showMonthDropdown: o.props.showMonthDropdown,
          showMonthYearDropdown: o.props.showMonthYearDropdown,
          showYearDropdown: o.props.showYearDropdown,
          withPortal: o.props.withPortal,
          monthRef: o.state.monthContainer,
          injectTimes: o.props.injectTimes,
          locale: o.props.locale
        });
      }), ue(De(o), "renderInputTimeSection", function () {
        var e = new Date(o.props.selected),
            r = "".concat(dt(e.getHours()), ":").concat(dt(e.getMinutes()));
        if (o.props.showTimeInput) return t.createElement(St, {
          timeString: r,
          timeInputLabel: o.props.timeInputLabel,
          onChange: o.props.onTimeChange,
          customTimeInput: o.props.customTimeInput
        });
      }), o.containerRef = t.createRef(), o.state = {
        date: o.getDateInView(),
        selectingDate: null,
        monthContainer: null
      }, o;
    }

    return de(a, null, [{
      key: "defaultProps",
      get: function get() {
        return {
          onDropdownFocus: function onDropdownFocus() {},
          monthsShown: 1,
          monthSelectedIn: 0,
          forceShowMonthNavigation: !1,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          customTimeInput: null
        };
      }
    }]), de(a, [{
      key: "componentDidMount",
      value: function value() {
        var e = this;
        this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
          monthContainer: e.monthContainer
        }));
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        this.props.preSelection && !Re(this.props.preSelection, e.preSelection) ? this.setState({
          date: this.props.preSelection
        }) : this.props.openToDate && !Re(this.props.openToDate, e.openToDate) && this.setState({
          date: this.props.openToDate
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.container || Pt;
        return t.createElement("div", {
          ref: this.containerRef
        }, t.createElement(e, {
          className: n("react-datepicker", this.props.className, {
            "react-datepicker--time-only": this.props.showTimeSelectOnly
          }),
          showPopperArrow: this.props.showPopperArrow
        }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.props.children));
      }
    }]), a;
  }(t.Component),
      Nt = function Nt(e) {
    return !e.disabled && -1 !== e.tabIndex;
  },
      Yt = function (e) {
    ye(n, e);
    var r = ge(n);

    function n(e) {
      var a;
      return ce(this, n), ue(De(a = r.call(this, e)), "getTabChildren", function () {
        return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(Nt);
      }), ue(De(a), "handleFocusStart", function (e) {
        var t = a.getTabChildren();
        t && t.length > 1 && t[t.length - 1].focus();
      }), ue(De(a), "handleFocusEnd", function (e) {
        var t = a.getTabChildren();
        t && t.length > 1 && t[0].focus();
      }), a.tabLoopRef = t.createRef(), a;
    }

    return de(n, null, [{
      key: "defaultProps",
      get: function get() {
        return {
          enableTabLoop: !0
        };
      }
    }]), de(n, [{
      key: "render",
      value: function value() {
        return this.props.enableTabLoop ? t.createElement("div", {
          className: "react-datepicker__tab-loop",
          ref: this.tabLoopRef
        }, t.createElement("div", {
          className: "react-datepicker__tab-loop__start",
          tabIndex: "0",
          onFocus: this.handleFocusStart
        }), this.props.children, t.createElement("div", {
          className: "react-datepicker__tab-loop__end",
          tabIndex: "0",
          onFocus: this.handleFocusEnd
        })) : this.props.children;
      }
    }]), n;
  }(t.Component),
      xt = function (e) {
    ye(a, e);
    var r = ge(a);

    function a() {
      return ce(this, a), r.apply(this, arguments);
    }

    return de(a, [{
      key: "render",
      value: function value() {
        var e,
            r = this.props,
            a = r.className,
            o = r.wrapperClassName,
            s = r.hidePopper,
            p = r.popperComponent,
            i = r.popperModifiers,
            c = r.popperPlacement,
            l = r.popperProps,
            d = r.targetComponent,
            u = r.enableTabLoop,
            h = r.popperOnKeyDown;

        if (!s) {
          var f = n("react-datepicker-popper", a);
          e = t.createElement(pe.Popper, he({
            modifiers: i,
            placement: c
          }, l), function (e) {
            var r = e.ref,
                n = e.style,
                a = e.placement,
                o = e.arrowProps;
            return t.createElement(Yt, {
              enableTabLoop: u
            }, t.createElement("div", he({
              ref: r,
              style: n
            }, {
              className: f,
              "data-placement": a,
              onKeyDown: h
            }), t.cloneElement(p, {
              arrowProps: o
            })));
          });
        }

        this.props.popperContainer && (e = t.createElement(this.props.popperContainer, {}, e));
        var m = n("react-datepicker-wrapper", o);
        return t.createElement(pe.Manager, {
          className: "react-datepicker-manager"
        }, t.createElement(pe.Reference, null, function (e) {
          var r = e.ref;
          return t.createElement("div", {
            ref: r,
            className: m
          }, d);
        }), e);
      }
    }], [{
      key: "defaultProps",
      get: function get() {
        return {
          hidePopper: !0,
          popperModifiers: {
            preventOverflow: {
              enabled: !0,
              escapeWithReference: !0,
              boundariesElement: "viewport"
            }
          },
          popperProps: {},
          popperPlacement: "bottom-start"
        };
      }
    }]), a;
  }(t.Component),
      Tt = se(Et);

  var It = function (e) {
    ye(o, e);
    var r = ge(o);

    function o(e) {
      var s;
      return ce(this, o), ue(De(s = r.call(this, e)), "getPreSelection", function () {
        return s.props.openToDate ? s.props.openToDate : s.props.selectsEnd && s.props.startDate ? s.props.startDate : s.props.selectsStart && s.props.endDate ? s.props.endDate : Se();
      }), ue(De(s), "calcInitialState", function () {
        var e = s.getPreSelection(),
            t = pt(s.props),
            r = it(s.props),
            n = t && te(e, t) ? t : r && ee(e, r) ? r : e;
        return {
          open: s.props.startOpen || !1,
          preventFocus: !1,
          preSelection: s.props.selected ? s.props.selected : n,
          highlightDates: ct(s.props.highlightDates),
          focused: !1
        };
      }), ue(De(s), "clearPreventFocusTimeout", function () {
        s.preventFocusTimeout && clearTimeout(s.preventFocusTimeout);
      }), ue(De(s), "setFocus", function () {
        s.input && s.input.focus && s.input.focus();
      }), ue(De(s), "setBlur", function () {
        s.input && s.input.blur && s.input.blur(), s.cancelFocusInput();
      }), ue(De(s), "setOpen", function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
        s.setState({
          open: e,
          preSelection: e && s.state.open ? s.state.preSelection : s.calcInitialState().preSelection,
          lastPreSelectChange: jt
        }, function () {
          e || s.setState(function (e) {
            return {
              focused: !!t && e.focused
            };
          }, function () {
            !t && s.setBlur(), s.setState({
              inputValue: null
            });
          });
        });
      }), ue(De(s), "inputOk", function () {
        return a(s.state.preSelection);
      }), ue(De(s), "isCalendarOpen", function () {
        return void 0 === s.props.open ? s.state.open && !s.props.disabled && !s.props.readOnly : s.props.open;
      }), ue(De(s), "handleFocus", function (e) {
        s.state.preventFocus || (s.props.onFocus(e), s.props.preventOpenOnFocus || s.props.readOnly || s.setOpen(!0)), s.setState({
          focused: !0
        });
      }), ue(De(s), "cancelFocusInput", function () {
        clearTimeout(s.inputFocusTimeout), s.inputFocusTimeout = null;
      }), ue(De(s), "deferFocusInput", function () {
        s.cancelFocusInput(), s.inputFocusTimeout = setTimeout(function () {
          return s.setFocus();
        }, 1);
      }), ue(De(s), "handleDropdownFocus", function () {
        s.cancelFocusInput();
      }), ue(De(s), "handleBlur", function (e) {
        (!s.state.open || s.props.withPortal || s.props.showTimeInput) && s.props.onBlur(e), s.setState({
          focused: !1
        });
      }), ue(De(s), "handleCalendarClickOutside", function (e) {
        s.props.inline || s.setOpen(!1), s.props.onClickOutside(e), s.props.withPortal && e.preventDefault();
      }), ue(De(s), "handleChange", function () {
        for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) {
          t[r] = arguments[r];
        }

        var n = t[0];

        if (!s.props.onChangeRaw || (s.props.onChangeRaw.apply(De(s), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
          s.setState({
            inputValue: n.target.value,
            lastPreSelectChange: Lt
          });
          var a = Pe(n.target.value, s.props.dateFormat, s.props.locale, s.props.strictParsing);
          !a && n.target.value || s.setSelected(a, n, !0);
        }
      }), ue(De(s), "handleSelect", function (e, t, r) {
        s.setState({
          preventFocus: !0
        }, function () {
          return s.preventFocusTimeout = setTimeout(function () {
            return s.setState({
              preventFocus: !1
            });
          }, 50), s.preventFocusTimeout;
        }), s.setSelected(e, t, !1, r), !s.props.shouldCloseOnSelect || s.props.showTimeSelect ? s.setPreSelection(e) : s.props.inline || s.setOpen(!1);
      }), ue(De(s), "setSelected", function (e, t, r, n) {
        var a = e;
        null !== a && $e(a, s.props) || (Ae(s.props.selected, a) && !s.props.allowSameDay || (null !== a && (!s.props.selected || r && (s.props.showTimeSelect || s.props.showTimeSelectOnly || s.props.showTimeInput) || (a = Ne(a, {
          hour: g(s.props.selected),
          minute: k(s.props.selected),
          second: D(s.props.selected)
        })), s.props.inline || s.setState({
          preSelection: a
        }), s.props.inline && s.props.monthsShown > 1 && !s.props.inlineFocusSelectedMonth && s.setState({
          monthSelectedIn: n
        })), s.props.onChange(a, t)), s.props.onSelect(a, t), r || s.setState({
          inputValue: null
        }));
      }), ue(De(s), "setPreSelection", function (e) {
        var t = void 0 !== s.props.minDate,
            r = void 0 !== s.props.maxDate,
            n = !0;
        e && (t && r ? n = Be(e, s.props.minDate, s.props.maxDate) : t ? n = ee(e, s.props.minDate) : r && (n = te(e, s.props.maxDate))), n && s.setState({
          preSelection: e
        });
      }), ue(De(s), "handleTimeChange", function (e) {
        var t = Ne(s.props.selected ? s.props.selected : s.getPreSelection(), {
          hour: g(e),
          minute: k(e)
        });
        s.setState({
          preSelection: t
        }), s.props.onChange(t), s.props.shouldCloseOnSelect && s.setOpen(!1), s.props.showTimeInput && s.setOpen(!0), s.setState({
          inputValue: null
        });
      }), ue(De(s), "onInputClick", function () {
        s.props.disabled || s.props.readOnly || s.setOpen(!0), s.props.onInputClick();
      }), ue(De(s), "onInputKeyDown", function (e) {
        s.props.onKeyDown(e);
        var t = e.key;

        if (s.state.open || s.props.inline || s.props.preventOpenOnFocus) {
          if (s.state.open) {
            if ("ArrowDown" === t || "ArrowUp" === t) {
              e.preventDefault();
              var r = s.calendar.componentNode && s.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
              return void (r && r.focus());
            }

            var n = Se(s.state.preSelection);
            "Enter" === t ? (e.preventDefault(), s.inputOk() && s.state.lastPreSelectChange === jt ? (s.handleSelect(n, e), !s.props.shouldCloseOnSelect && s.setPreSelection(n)) : s.setOpen(!1)) : "Escape" === t && (e.preventDefault(), s.setOpen(!1)), s.inputOk() || s.props.onInputError({
              code: 1,
              msg: "Date input not valid."
            });
          }
        } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || s.onInputClick();
      }), ue(De(s), "onDayKeyDown", function (e) {
        s.props.onKeyDown(e);
        var t = e.key,
            r = Se(s.state.preSelection);
        if ("Enter" === t) e.preventDefault(), s.handleSelect(r, e), !s.props.shouldCloseOnSelect && s.setPreSelection(r);else if ("Escape" === t) e.preventDefault(), s.setOpen(!1), s.inputOk() || s.props.onInputError({
          code: 1,
          msg: "Date input not valid."
        });else if (!s.props.disabledKeyboardNavigation) {
          var n;

          switch (t) {
            case "ArrowLeft":
              n = m(r, 1);
              break;

            case "ArrowRight":
              n = c(r, 1);
              break;

            case "ArrowUp":
              n = y(r, 1);
              break;

            case "ArrowDown":
              n = l(r, 1);
              break;

            case "PageUp":
              n = v(r, 1);
              break;

            case "PageDown":
              n = d(r, 1);
              break;

            case "Home":
              n = w(r, 1);
              break;

            case "End":
              n = u(r, 1);
          }

          if (!n) return void (s.props.onInputError && s.props.onInputError({
            code: 1,
            msg: "Date input not valid."
          }));
          e.preventDefault(), s.setState({
            lastPreSelectChange: jt
          }), s.props.adjustDateOnChange && s.setSelected(n), s.setPreSelection(n);
        }
      }), ue(De(s), "onPopperKeyDown", function (e) {
        "Escape" === e.key && (e.preventDefault(), s.setState({
          preventFocus: !0
        }, function () {
          s.setOpen(!1), setTimeout(function () {
            s.setFocus(), s.setState({
              preventFocus: !1
            });
          });
        }));
      }), ue(De(s), "onClearClick", function (e) {
        e && e.preventDefault && e.preventDefault(), s.props.onChange(null, e), s.setState({
          inputValue: null
        });
      }), ue(De(s), "clear", function () {
        s.onClearClick();
      }), ue(De(s), "renderCalendar", function () {
        return s.props.inline || s.isCalendarOpen() ? t.createElement(Tt, {
          ref: function ref(e) {
            s.calendar = e;
          },
          locale: s.props.locale,
          chooseDayAriaLabelPrefix: s.props.chooseDayAriaLabelPrefix,
          disabledDayAriaLabelPrefix: s.props.disabledDayAriaLabelPrefix,
          weekAriaLabelPrefix: s.props.weekAriaLabelPrefix,
          adjustDateOnChange: s.props.adjustDateOnChange,
          setOpen: s.setOpen,
          shouldCloseOnSelect: s.props.shouldCloseOnSelect,
          dateFormat: s.props.dateFormatCalendar,
          useWeekdaysShort: s.props.useWeekdaysShort,
          formatWeekDay: s.props.formatWeekDay,
          dropdownMode: s.props.dropdownMode,
          selected: s.props.selected,
          preSelection: s.state.preSelection,
          onSelect: s.handleSelect,
          onWeekSelect: s.props.onWeekSelect,
          openToDate: s.props.openToDate,
          minDate: s.props.minDate,
          maxDate: s.props.maxDate,
          selectsStart: s.props.selectsStart,
          selectsEnd: s.props.selectsEnd,
          startDate: s.props.startDate,
          endDate: s.props.endDate,
          excludeDates: s.props.excludeDates,
          filterDate: s.props.filterDate,
          onClickOutside: s.handleCalendarClickOutside,
          formatWeekNumber: s.props.formatWeekNumber,
          highlightDates: s.state.highlightDates,
          includeDates: s.props.includeDates,
          includeTimes: s.props.includeTimes,
          injectTimes: s.props.injectTimes,
          inline: s.props.inline,
          peekNextMonth: s.props.peekNextMonth,
          showMonthDropdown: s.props.showMonthDropdown,
          showPreviousMonths: s.props.showPreviousMonths,
          useShortMonthInDropdown: s.props.useShortMonthInDropdown,
          showMonthYearDropdown: s.props.showMonthYearDropdown,
          showWeekNumbers: s.props.showWeekNumbers,
          showYearDropdown: s.props.showYearDropdown,
          withPortal: s.props.withPortal,
          forceShowMonthNavigation: s.props.forceShowMonthNavigation,
          showDisabledMonthNavigation: s.props.showDisabledMonthNavigation,
          scrollableYearDropdown: s.props.scrollableYearDropdown,
          scrollableMonthYearDropdown: s.props.scrollableMonthYearDropdown,
          todayButton: s.props.todayButton,
          weekLabel: s.props.weekLabel,
          outsideClickIgnoreClass: "react-datepicker-ignore-onclickoutside",
          fixedHeight: s.props.fixedHeight,
          monthsShown: s.props.monthsShown,
          monthSelectedIn: s.state.monthSelectedIn,
          onDropdownFocus: s.handleDropdownFocus,
          onMonthChange: s.props.onMonthChange,
          onYearChange: s.props.onYearChange,
          dayClassName: s.props.dayClassName,
          weekDayClassName: s.props.weekDayClassName,
          monthClassName: s.props.monthClassName,
          timeClassName: s.props.timeClassName,
          showTimeSelect: s.props.showTimeSelect,
          showTimeSelectOnly: s.props.showTimeSelectOnly,
          onTimeChange: s.handleTimeChange,
          timeFormat: s.props.timeFormat,
          timeIntervals: s.props.timeIntervals,
          minTime: s.props.minTime,
          maxTime: s.props.maxTime,
          excludeTimes: s.props.excludeTimes,
          timeCaption: s.props.timeCaption,
          className: s.props.calendarClassName,
          container: s.props.calendarContainer,
          yearDropdownItemNumber: s.props.yearDropdownItemNumber,
          previousMonthButtonLabel: s.props.previousMonthButtonLabel,
          nextMonthButtonLabel: s.props.nextMonthButtonLabel,
          previousYearButtonLabel: s.props.previousYearButtonLabel,
          nextYearButtonLabel: s.props.nextYearButtonLabel,
          timeInputLabel: s.props.timeInputLabel,
          disabledKeyboardNavigation: s.props.disabledKeyboardNavigation,
          renderCustomHeader: s.props.renderCustomHeader,
          popperProps: s.props.popperProps,
          renderDayContents: s.props.renderDayContents,
          onDayMouseEnter: s.props.onDayMouseEnter,
          onMonthMouseLeave: s.props.onMonthMouseLeave,
          showTimeInput: s.props.showTimeInput,
          showMonthYearPicker: s.props.showMonthYearPicker,
          showFullMonthYearPicker: s.props.showFullMonthYearPicker,
          showYearPicker: s.props.showYearPicker,
          showQuarterYearPicker: s.props.showQuarterYearPicker,
          showPopperArrow: s.props.showPopperArrow,
          excludeScrollbar: s.props.excludeScrollbar,
          handleOnKeyDown: s.onDayKeyDown,
          isInputFocused: s.state.focused,
          customTimeInput: s.props.customTimeInput,
          setPreSelection: s.setPreSelection
        }, s.props.children) : null;
      }), ue(De(s), "renderDateInput", function () {
        var e,
            r,
            a,
            o,
            p,
            i = n(s.props.className, ue({}, "react-datepicker-ignore-onclickoutside", s.state.open)),
            c = s.props.customInput || t.createElement("input", {
          type: "text"
        }),
            l = s.props.customInputRef || "ref",
            d = "string" == typeof s.props.value ? s.props.value : "string" == typeof s.state.inputValue ? s.state.inputValue : (r = s.props.selected, a = s.props, o = a.dateFormat, p = a.locale, r && Ee(r, Array.isArray(o) ? o[0] : o, p) || "");
        return t.cloneElement(c, (ue(e = {}, l, function (e) {
          s.input = e;
        }), ue(e, "value", d), ue(e, "onBlur", s.handleBlur), ue(e, "onChange", s.handleChange), ue(e, "onClick", s.onInputClick), ue(e, "onFocus", s.handleFocus), ue(e, "onKeyDown", s.onInputKeyDown), ue(e, "id", s.props.id), ue(e, "name", s.props.name), ue(e, "autoFocus", s.props.autoFocus), ue(e, "placeholder", s.props.placeholderText), ue(e, "disabled", s.props.disabled), ue(e, "autoComplete", s.props.autoComplete), ue(e, "className", n(c.props.className, i)), ue(e, "title", s.props.title), ue(e, "readOnly", s.props.readOnly), ue(e, "required", s.props.required), ue(e, "tabIndex", s.props.tabIndex), ue(e, "aria-labelledby", s.props.ariaLabelledBy), e));
      }), ue(De(s), "renderClearButton", function () {
        var e = s.props,
            r = e.isClearable,
            n = e.selected,
            a = e.clearButtonTitle,
            o = e.ariaLabelClose,
            p = void 0 === o ? "Close" : o;
        return r && null != n ? t.createElement("button", {
          type: "button",
          className: "react-datepicker__close-icon",
          "aria-label": p,
          onClick: s.onClearClick,
          title: a,
          tabIndex: -1
        }) : null;
      }), s.state = s.calcInitialState(), s;
    }

    return de(o, null, [{
      key: "defaultProps",
      get: function get() {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          onChange: function onChange() {},
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          onFocus: function onFocus() {},
          onBlur: function onBlur() {},
          onKeyDown: function onKeyDown() {},
          onInputClick: function onInputClick() {},
          onSelect: function onSelect() {},
          onClickOutside: function onClickOutside() {},
          onMonthChange: function onMonthChange() {},
          onCalendarOpen: function onCalendarOpen() {},
          onCalendarClose: function onCalendarClose() {},
          preventOpenOnFocus: !1,
          onYearChange: function onYearChange() {},
          onInputError: function onInputError() {},
          monthsShown: 1,
          readOnly: !1,
          withPortal: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          strictParsing: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          renderDayContents: function renderDayContents(e) {
            return e;
          },
          inlineFocusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null
        };
      }
    }]), de(o, [{
      key: "componentDidUpdate",
      value: function value(e, t) {
        var r, n;
        e.inline && (r = e.selected, n = this.props.selected, r && n ? O(r) !== O(n) || P(r) !== P(n) : r !== n) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
          monthSelectedIn: 0
        }), e.highlightDates !== this.props.highlightDates && this.setState({
          highlightDates: ct(this.props.highlightDates)
        }), t.focused || Ae(e.selected, this.props.selected) || this.setState({
          inputValue: null
        }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.clearPreventFocusTimeout();
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.renderCalendar();
        return this.props.inline && !this.props.withPortal ? e : this.props.withPortal ? t.createElement("div", null, this.props.inline ? null : t.createElement("div", {
          className: "react-datepicker__input-container"
        }, this.renderDateInput(), this.renderClearButton()), this.state.open || this.props.inline ? t.createElement("div", {
          className: "react-datepicker__portal"
        }, e) : null) : t.createElement(xt, {
          className: this.props.popperClassName,
          wrapperClassName: this.props.wrapperClassName,
          hidePopper: !this.isCalendarOpen(),
          popperModifiers: this.props.popperModifiers,
          targetComponent: t.createElement("div", {
            className: "react-datepicker__input-container"
          }, this.renderDateInput(), this.renderClearButton()),
          popperContainer: this.props.popperContainer,
          popperComponent: e,
          popperPlacement: this.props.popperPlacement,
          popperProps: this.props.popperProps,
          popperOnKeyDown: this.onPopperKeyDown,
          enableTabLoop: this.props.enableTabLoop
        });
      }
    }]), o;
  }(t.Component),
      Lt = "input",
      jt = "navigate";

  e.CalendarContainer = Pt, e.default = It, e.getDefaultLocale = He, e.registerLocale = function (e, t) {
    var r = "undefined" != typeof window ? window : global;
    r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
  }, e.setDefaultLocale = function (e) {
    ("undefined" != typeof window ? window : global).__localeId__ = e;
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});